<div class="table-top-bar">
  <div class="d-flex justify-content-between align-items-center">
    <div class="show-per-page-container col">
      <div class="row justify-content-start" *ngIf="shouldShowAddButton()">
        <button class="btn btn-primary filter-btn-add" (click)="onAddNew()">
          <span class="oi oi-plus"></span>
          {{ addAction.addButtonText || 'Add New' }}
        </button>
        <ng-container *ngTemplateOutlet="addButtonLeft"></ng-container>
      </div>
    </div>
    <div class="right col text-right">
      <div
        class="filter-btn-fields row justify-content-end"
        dropdown
        [insideClick]="true"
        placement="bottom right"
      >
        <ng-container *ngTemplateOutlet="addButtonRight"></ng-container>
        <div class="export-excel" *ngIf="shouldShowExcelButton() && !isLoading">
          <button
            (click)="onExportExcel()"
            class="btn btn-primary"
            type="button"
          >
            <span class="oi oi-data-transfer-download"></span> Export Excel
          </button>
        </div>

        <ng-container *ngIf="visibleColumns">
          <button
            id="button-basic"
            dropdownToggle
            type="button"
            class="btn btn-primary dropdown-toggle"
            aria-controls="dropdown-basic"
          >
            Show Fields
          </button>

          <ul
            id="dropdown-basic"
            *dropdownMenu
            class="custom-dropdown-menu dropdown-config-filter dropdown-menu-right"
            role="menu"
            aria-labelledby="button-basic"
          >
            <ng-container *ngFor="let fieldModel of fieldsToShow">
              <li
                *ngIf="!fieldModel.settings.hide"
                role="menuitem"
                class="fields-item"
              >
                <div
                  class="btn-checkbox checkbox-item {{
                    checkColDisplay(fieldModel.settings.fieldName)
                      ? 'checked'
                      : 'no-check'
                  }}"
                  type="button"
                  (click)="changeStatus(fieldModel.settings.fieldName)"
                >
                  {{ fieldModel.settings.title }}
                </div>
              </li>
            </ng-container>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
</div>
